import React from 'react';
import ProjectFragment from './mainPageFragments/projectFragment/projectsFragment';

const Projects = () => {
  return (
    <>
      <ProjectFragment />
    </>
  );
};

export default Projects;
